<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-07-26 10:50:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-19 17:26:38
 * @FilePath: /chaoyongtuan/src/components/common/tipsBox/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<!--保持不变-->
		<div class="tipsBox mb-10 flex flex-align-center" v-if="isDarenPartner">
			<i class="el-icon-info iconfont-color"></i>
			<span class="font-h6-regular yx-color-text-primary">注意：您正在协助达人招商进行操作，本次操作将会同步到达人招商选品小程序中，请与相应达人招商确认后进行操作！</span>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	name: 'tipsBox',
	props: {},
	computed: {
		...mapGetters(['isDarenPartner']),
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
.tipsBox {
	border-radius: 4px;
	background: #FFF0EB;
	border: 1px solid #FFE2D7;
	padding: 8px 16px 8px 16px;
}
.iconfont-color{
	margin-right: 5px;
	color: @color-o;
}
</style>
